export function sceneLoadTargetId(sl: { load?: number; load_id?: number }): number {
	return sl.load ?? sl.load_id ?? 0;
}
